


$(window).on("load",function(){

  if (_ua.Mobile){
    $('.slide-img').css('height',$(window).height()-68);
    $('#em_btn a').matchHeight();
    }else{
    }

    var title = $(".about_title .company");
    var title2 = $(".about_title .mainen");
    var title3 = $(".about_title h1");

    gsap.fromTo(".tanim", {
      opacity:0,y:10,
    },
    {
      opacity:1,y:0,
      duration: 0.5,
      stagger: 0.3 //space each element's animation out by 0.5 seconds
    });
    

})


$(function(){




  if(_ua.Mobile){
    sp_menu();
  }else{
    pc_menu();
  }

  inview();
  ipad_view();
  head_fixed_margin();
  pagetop();
  smooth();








});


function inview(){
  $('.inview').on('inview', function(event, visible, topOrBottomOrBoth) {
if (visible) {
          $(this).addClass('active');
} else {
}
});
}


function pc_menu(){




  $("#gnav_pc ul li.mainli").on('mouseenter',function(){
    $(".overlay").addClass('active');
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    $(this).find(".megamenu_block").addClass('is-open');
    $(this).find(".megamenu_block").siblings().removeClass('is-open');
  });
  $("#gnav_pc ul li.mainli").on('mouseleave',function(){
    $(".overlay").removeClass('active');
    $(this).removeClass('active');
    $(this).find(".megamenu_block").removeClass('is-open');
  })

  var state = false;

  $("#spmenu").on('click',function(){
 
     $(this).toggleClass('active');
     $("#gnav").toggleClass('is-open');
     $("#gnav_pc").toggleClass('is-hopen');
   })

  /*
  const ps = new PerfectScrollbar('.scroll', {
      wheelSpeed: 2,
      wheelPropagation: true,
      minScrollbarLength: 20
  });

  $(window).on('resize',function() {
      ps.update();
  });
   */

  $(".site_menu").on('click', function(){
      
     });


     var mediaQuery = matchMedia('(max-width: 798px)');
     handle(mediaQuery);
     mediaQuery.addListener(handle);
     function handle(mq) {
       if (mq.matches) {
         $ (".gmain").on('click',function(){
           $(this).next(".gsub").slideToggle();
           $(this).toggleClass("active");
           $(this).next(".gsub").toggleClass("active");
          
       });
       } else {
         
       }
     }

}

function head_fixed_margin(){

      reviseMargin();
 
  var hh = $("header").height();
  function reviseMargin(){
      $("body").css({
  "padding-top":"60px",
      });
  }
  function reviseMargin_sp(){
    $("body").css({
  "padding-top":"50px",
    });
  }
  }



function sp_menu(){

  $(".site_menu").on('click',function(){
    $(this).toggleClass('is-open');
    $("#gnav").toggleClass('is-open');
    $("#gnav_pc").toggleClass('is-hopen');
    $("body").toggleClass('is-fixed');
  })





  $(window).on('resize',function() {
      ps.update();
  });


   $ (".gmain").on('click',function(){
    $(this).next(".gsub").slideToggle("");
    $(this).toggleClass("active");
    $(this).next(".gsub").toggleClass("active");
   
});

var state = true;


$(".site_menu").on('click', function(){
 if(state == false) {
   var scrollpos = $(window).scrollTop();
   $('body').addClass('fixed').css({'top': -scrollpos});
   $( 'html, body' ).prop( { scrollTop: scrollpos } );
   state = true;
 } else {
   $('body').removeClass('fixed').css({'top': 0});
   window.scrollTo( 0 , scrollpos );
   state = false;
 }
});


}

function coming(){

     $('.coming a').click(function(event){
          return false;
          event.preventDefault();
     });
     $('.nolink a').click(function(event){
          event.preventDefault();
     });
		 $('a.nolink').click(function(event){
          event.preventDefault();
     });
}


function ipad_view(){
  if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
    $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">');
  }else if(_ua.Tablet){
        $('head').prepend('<meta name="viewport" content="width=1280">');
        $("body").addClass("ipad_view");
    }

}

function sp_menu(){





  $("#spmenu").on('click',function(){
    $(this).toggleClass('active');
    $("#gnav").toggleClass('is-open');
    $("#gnav_pc").toggleClass('is-hopen');
    $("body").toggleClass('is-fixed');
  })



/* 
   $('.scroll').perfectScrollbar({
       wheelSpeed: 2,
       wheelPropagation: true,
       minScrollbarLength: 20
   });

   $(window).resize(function() {
     $('.scroll').perfectScrollbar('update');
   });
*/

   $ (".gmain").click(function(){
    $(this).next(".gsub").slideToggle("");
    $(this).toggleClass("active");
    $(this).next(".gsub").toggleClass("active");
   
});


$(".site_menu").on('click', function(){
 if(state == false) {
   scrollpos = $(window).scrollTop();
   $('body').addClass('fixed').css({'top': -scrollpos});
   $( 'html, body' ).prop( { scrollTop: scrollpos } );
   state = true;
 } else {
   $('body').removeClass('fixed').css({'top': 0});
   window.scrollTo( 0 , scrollpos );

   state = false;
 }
});


}







function smooth(){

     // #で始まるアンカーをクリックした場合に処理
   $('a[href^="#"].smooth').click(function() {


      var hh = $("header").outerHeight();

      var href= $(this).attr("href");
      // 移動先を取得
      var target = $(href == "#" || href == "" ? 'html' : href);
      // 移動先を数値で取得
      if (_ua.Mobile){
           var position = target.offset().top-50;
      }else if($(this).hasClass("smin")){
           var position = target.offset().top-hh;
      }else{
          var position = target.offset().top;
      }


gsap.to(window, {duration: 0.5, scrollTo: position});
      return false;
   });

}


function inview2(){
  //スクロール発火処理
function scrollEffect(){
  $(".inview").each(function(){
    var scroll = $(window).scrollTop();//現在のyスクロール量を取得
    var windowHeight = $(window).height();//ウィンドウの高さを取得
    var tgtPos = $(this).offset().top//ターゲットのy位置を取得
    var subjectHeight = $(this).innerHeight();//ターゲットの高さを取得
    var threshould;//閾値
    var w = $(window).width();
    threshould = tgtPos - windowHeight - 150;//発火位置調整
    //
    if (scroll > threshould) {//クラスを付与する処理
      $(this).addClass("active");
    }
  });
}
$(window).scroll(function(){
scrollEffect();
});
}

function inview(){
  $('.inview').on('inview', function(event, visible, topOrBottomOrBoth) {
if (visible) {
          $(this).addClass('active');
} else {
}
});
}


function pagetop(){

     $(window).scroll(function () {
          var pagetop = $('#pagetop');
          if ($(this).scrollTop() > 100) {
               pagetop.addClass("active");
          } else {
               pagetop.removeClass("active");
          }
     });
     $("#pagetop").click(function(event) {
      gsap.to(window, {duration: 0.8, scrollTo: 0});
      });
}





function pagetop(){

  $(window).scroll(function () {
       var pagetop = $('#pagetop');
       if ($(this).scrollTop() > 100) {
            pagetop.addClass("active");
       } else {
            pagetop.removeClass("active");
       }
  });
  $("#pagetop").click(function(event) {
   gsap.to(window, {duration: 0.8, scrollTo: 0});
   });
}



function ptop_anim(){
     var p =$("#pagetop");
     var t =$("#pagetop .inner");

     TweenMax.set(t, {
          scale:0,
     });

     p.hover(function(){
          TweenMax.to(t, 0.5, {
               scale:1.3,
               ease:Expo.easeOut,
          });
     },function(){
          TweenMax.to(t, 0.3, {
               scale:0,ease:Expo.easeOut,
          });
     });




}
